import { Article, DictionaryEntry, LinkItem } from './models';

export const DEFAULT_ARTICLES: Article[] = [
    {
      id: '1',
      slug: 'nelson-mandela',
      title: 'نلسن منڈیلا: لڑتا ہے اور ہاتھ میں تلوار بھی نہیں',
      excerpt:
        'نلسن مینڈیلا مشہور آزادی کے متوالوں میں سے ہیں جنہوں نے اپنی ساری زندگی نسل پرست طاقتوں سے لڑتے گزاری اور اپنے ملک جنوبی افریقہ کو آزادی دلائی۔',
      body: [
        'نلسن مینڈیلا مشہور آزادی کے متوالوں میں سے ہیں جنہوں نے اپنی ساری زندگی نسل پرست طاقتوں سے لڑتے گزاری اور اپنے ملک جنوبی افریقہ کو آزادی دلائی۔ مینڈیلا جولائی 18، 1918 کو پیدا ہوئے تھے۔ ان کے باپ مقامی قبیلہ کے سرکردہ رہنما تھے۔',
        "مینڈیلا کو بچپن میں 'رولیہلاہلا' پیار کا نام دیا گیا تھا جس کے معنی ان کی زبان 'خوسہ' میں شریر کے ہوتے ہیں۔ ان کا انتقال 5 دسمبر 2013 کو جوہانس برگ، جنوبی افریقہ، میں ہوا۔",
        '1964 میں ان پر مقدمہ چلا۔ استغاثہ نے انہیں ملک کے خلاف سازش کا مجرم قرار دیا۔ مینڈیلا نے قید میں اٹھائیس سال گزارے مگر اپنے اصولوں سے پیچھے نہیں ہٹے۔ آج دنیا انہیں امن، بردباری اور انسانی وقار کی علامت سمجھتی ہے۔'
      ],
      image: 'images/mandela.jpg',
      language: 'urdu',
      category: 'تاریخ',
      featured: true,
      date: '2026-01-12'
    },
    {
      id: '2',
      slug: 'coffee-part-3',
      title: 'کافی قسط 3',
      excerpt:
        "بوسٹن ٹی پارٹی کے واقعے سے پہلے برطانیہ کی امریکی نوآبادی کی اکثریت چائے کی رسیا تھی۔ احتجاج کے بعد کافی امریکہ کا قومی مشروب بن گئی۔",
      body: [
        "بوسٹن ٹی پارٹی کے واقعے سے پہلے برطانیہ کی امریکی نوآبادی کی اکثریت چائے کی رسیا تھی اور برطانیہ میں تو یہ مشروبِ خاص تھا ہی۔",
        "1773 عیسوی میں برطانوی حکومت کی جانب سے چائے پر ٹیکس بڑھائے جانے پر امریکہ میں پرِجا نے گودیوں پر رکھی سینکڑوں درآمد شدہ پیٹیاں بطور احتجاج سمندر برد کر دیں۔ اُس زمانے کا مشہور نعرہ رہا 'نمائندگی نہیں، ٹیکس نہیں'۔",
        'اُس وقت سے امریکہ میں کافی پینا حب الوطنی سمجھا جانے لگا؛ اور کافی یہاں کا قومی مشروب ہو گیا۔'
      ],
      image: 'images/coffee.jpg',
      language: 'urdu',
      category: 'تاریخِ مشروبات',
      featured: true,
      date: '2026-01-10'
    },
    {
      id: '3',
      slug: 'alcohol-pleasure-or-punishment',
      title: 'شراب: مزا لوں یا لوں عذاب',
      excerpt:
        'اسلام میں شراب کی ممانعت ہے۔ اگر ہم شراب کے حقائق جاننا چاہیں اور تاریخ کے ماخذوں کو کھنگالیں تو دلچسپ باتیں سامنے آتی ہیں۔',
      body: [
        'اسلام میں شراب کی ممانعت ہے، اس سے دور رہنے کے لیے اللہ اور اس کے رسول نے سختی سے فرمایا ہے۔',
        'اگر ہم شراب کے حقائق جاننا چاہیں اور تاریخ کے ماخذوں کو کھنگالیں تو ہمیں پتا چلتا ہے کہ شراب سب سے پہلے مشرقی یورپ میں کوہِ قاف کے علاقے کے ملک جارجیا میں کوئی 7000 سے 5000 سال ق م پہلے کشید کی جاتی تھی۔',
        "تب سے ہی انسان 'انگور کی بیٹی' کو مختلف ناموں سے جانتا رہا۔ اس مضمون میں ہم اس کی تاریخ، اثرات اور سماجی پہلوؤں پر روشنی ڈالتے ہیں۔"
      ],
      image: 'images/alcohol.jpg',
      language: 'urdu',
      category: 'معاشرت',
      featured: true,
      date: '2026-01-08'
    },
    {
      id: '4',
      slug: 'dirty-water-polio',
      title: 'گندا پانی پولیو پانی',
      excerpt:
        'پولیو گندے پانی سے پھیلنے والی بیماری ہے۔ پاکستان اور افغانستان وہ دو ممالک ہیں جو آج بھی اس مرض سے بری طرح متاثر ہیں۔',
      body: [
        'پاکستان اور افغانستان وہ دو ممالک ہیں جو آج بھی، جبکہ دنیا کی ترقّی عروج پر ہے، پولیو جیسے موزی مرض سے بری طرح سے متاثّر ہیں۔',
        'پاکستان میں پشتونوں کا گھر خیبر پختونخواہ اس بیماری کی لپیٹ میں ہے۔ کہانی کا سب سے افسوسناک پہلو یہ ہے کہ وہاں بہت سے لوگ اُس ویکسین کے خلاف مزاحمت کر رہے ہیں جو اُن کے بچّوں کو اس بیماری سے بچا سکتی ہے۔',
        'اس سلسلے میں انہیں باقاعدہ آگاہی دینے اور صاف پانی کی اہمیت سمجھانے کی شدید ضرورت ہے۔'
      ],
      image: 'images/water.jpg',
      language: 'urdu',
      category: 'صحت',
      date: '2026-01-05'
    },
    {
      id: '5',
      slug: 'wind-not-bombs',
      title: 'بمباری؟ جی نہیں ریاح کاری، چند حقائق',
      excerpt:
        'ہم یہاں ریاح کا ہی ذکر کریں گے لیکن مختصراً ڈکار کا بھی، کہ وہ بھی ایک ہوا ہے اور وہ بھی ہمارے پیٹ سے خارج ہوتی ہے۔',
      body: [
        'ہم یہاں ریاح کا ہی ذکر کریں گے لیکن مختصراً ڈکار کا بھی کہ وہ بھی ایک ہوا ہے اور وہ بھی ہمارے پیٹ سے خارج ہوتی ہے۔',
        'کسی زمانے میں مشرقی معاشروں میں کھانے کے بعد ڈکار لینا اچھا سمجھا جاتا تھا، کہ کھانے والے نے کھانے کو پسند کیا ہے۔ جبکہ جاپان، شمالی امریکہ اور یورپ میں کھانے کے دوران ڈکار لینا ایک معیوب بات تھی۔',
        'آئیے دیکھتے ہیں کہ وہ جسمانی عمل کیا ہے جو ہمیں اتنا قدرتی لگتا ہے مگر اس کے پیچھے سائنس بھی موجود ہے۔'
      ],
      image: 'images/wind.jpg',
      language: 'urdu',
      category: 'جسم و صحت',
      date: '2025-12-28'
    },
    {
      id: '6',
      slug: 'dawn-urdu',
      title: 'ڈان اردو خبر بن گیا',
      excerpt:
        'جنوری 2026 کے ابھی پندھرا دن بھی پورے نہیں ہوئے تھے کہ ڈان اخبار نے اپنا اردو کا برقی صفحہ شائع کرنا بند کر دیا۔',
      body: [
        'جنوری 2026 کے ابھی پندھرا دن بھی پورے نہیں ہوئے تھے کہ ڈان اخبار نے اپنا اردو کا برقی صفحہ شائع کرنا بند کر دیا۔ فروری 6 کو اس پر جو پرانے کالم اور مضامین پڑے تھے وہ بھی ہٹا دیے گئے ہیں۔',
        'ڈان اردو خاصے عرصے سے اچّھی صحافت کر رہا تھا۔ شروع میں کئی سال پہلے جب یہ شروع ہوا تھا تو بہت دلکش ہوا کرتا تھا، سمجھ لیں کہ بی بی سی اردو کی طرح، پڑھنے کا جی چاہتا تھا۔',
        'اردو صحافت کے لیے یہ ایک افسوسناک موڑ ہے، اور ہمیں سوچنا چاہیے کہ زبان اور علم کی ویب جگہیں کیوں ختم ہو رہی ہیں۔'
      ],
      image: 'images/news.jpg',
      language: 'urdu',
      category: 'میڈیا',
      date: '2026-02-08'
    },
    {
      id: '7',
      slug: 'insect-control',
      title: 'حشرات کی روک تھام',
      excerpt:
        'صنعت مسلسل ترقّی کر رہی ہے، لیکن تدبیر بھی ضروری ہے۔ آپ جہاں بھی رہیں حشرات ایک مسئلہ کی صورت میں وہاں موجود ہوتے ہیں۔',
      body: [
        'آپ جہاں بھی رہیں حشرات ایک مسئلہ کی صورت میں وہاں موجود ہوتے ہیں۔ اس سے فرق نہیں پڑتا کہ آپ کا گھر بالکل نیا ہے یا پرانا۔',
        'اور جب حملہ ہوتا ہے تو یہ بن بلائے مہمان اکیلے نہیں آتے بلکہ بے شمار مسائل اپنے ساتھ لاتے ہیں۔ کچھ نہیں تو دیکھنے ہی میں یہ خطرناک لگتے ہیں۔',
        'اس مضمون میں ہم حشرات کی روک تھام کے سادہ اور مؤثر طریقے بیان کرتے ہیں تاکہ گھر کی سہل زندگی برقرار رہے۔'
      ],
      image: 'images/insects.jpg',
      language: 'urdu',
      category: 'گھر و ماحول',
      date: '2025-12-20'
    },
    {
      id: '8',
      slug: 'greenland',
      title: 'گرین لینڈ',
      excerpt:
        'گرین لینڈ دنیا کا سب سے بڑا جزیرہ ہے۔ یہاں تقریباً چھپّن ہزار افراد آباد ہیں۔ زیادہ تر حصّہ برف کی چادر سے ڈھکا رہتا ہے۔',
      body: [
        'گرین لینڈ دنیا کا سب سے بڑا جزیرہ ہے۔ یہاں تقریباً چھپّن ہزار افراد آباد ہیں۔ اگرچہ یہ سلطنتِ ڈنمارک کا حصّہ ہے لیکن نظامِ حکومت گرین لینڈ کا اپنا ہے۔',
        'گرین لینڈ کا زیادہ تر حصّہ دائرۂ قطبِ شمالی کے شمال میں واقع ہے۔ اس کا کل رقبہ 21,66,086 مربّع کلومیٹر ہے، جس میں سے تقریباً 81 فیصد حصّہ برف کی چادر سے مستقل ڈھکا رہتا ہے۔',
        'یہاں موجود برف کا مجموعی حجم تقریباً 28,50,000 مکعب کلومیٹر ہے۔ موسمیاتی تبدیلی کے دور میں گرین لینڈ کی برف پگھلنا سمندر کی سطح کے لیے عالمی مسئلہ بن چکا ہے۔'
      ],
      image: 'images/greenland.jpg',
      language: 'urdu',
      category: 'جغرافیہ',
      date: '2025-12-15'
    },
    {
      id: '9',
      slug: 'coffee-part-2',
      title: 'کافی قسط 2',
      excerpt:
        "عرب کی شراب — سولہویں صدی میں جب ترکوں نے جزیرہ نما عرب پر قبضہ کیا تو کافی کی کھپت پوری سلطنتِ عثمانیہ میں پھیل گئی۔",
      body: [
        'سولہویں صدی میں جب ترکوں نے جزیرہ نما عرب پر قبضہ کیا تو کافی کی کھپت پوری سلطنتِ عثمانیہ میں پھیل گئی۔',
        "اس علاقے کے مسلمان نشہ آور مشروبات نہیں پیتے تھے اور کافی اس کا بہترین نعم البدل تھا اور یہ 'کاہوے' کہلایا جس کا مطلب تھا 'عرب کی شراب'۔",
        'ایک وقت وہ بھی تھا کہ کافی پینے والا موت کا سزاوار ہوتا۔ سلطنتِ عثمانیہ کے سلطان مراد چہارم قہوہ خانوں کو سخت ناپسند کرتے تھے۔'
      ],
      image: 'images/coffee.jpg',
      language: 'urdu',
      category: 'تاریخِ مشروبات',
      date: '2025-12-10'
    },
    {
      id: '10',
      slug: 'coffee-part-1',
      title: 'کافی قسط ایک',
      excerpt:
        'کافی دنیا کا سب سے زیادہ پسندیدہ گرم مشروب ہے۔ یہ عالمی منڈی کا ایک اہم جز ہے اور پٹرول کے بعد دوسری اہم ترین تجارت ہے۔',
      body: [
        'کافی دنیا کا سب سے زیادہ پسندیدہ گرم مشروب ہے۔ کافی لاکھوں لوگوں کو اپنے کام کے دوران چُست رکھتی ہے اور لاکھوں لوگ اپنے بہترین فارغ وقت میں اس کا لُطف اُٹھاتے ہیں۔',
        'یہ عالمی منڈی کا ایک اہم جز ہے اور پٹرول کے بعد دوسری اہم ترین تجارت ہے۔ کافی کا رنگ گہرا ہوتا ہے، ذائقے میں تلخ اور قدرے تیزابِیَت مائل ہے۔',
        'یہ انسانوں کے اندر اپنے بنیادی جز کیفین کی وجہ سے تحریک پیدا کرتی ہے۔ لفظِ کیفین کے بارے میں ہمیں معلوم ہونا چاہیے کہ یہ کافی سے اخذ شدہ ہے۔'
      ],
      image: 'images/coffee.jpg',
      language: 'urdu',
      category: 'تاریخِ مشروبات',
      date: '2025-12-05'
    },
    {
      id: '11',
      slug: 'aircraft-carrier',
      title: 'طیّارہ بردار جہاز',
      excerpt:
        'یو ایس ایس رونلڈ ریگن ایک 1,092 فٹ لمبا، 6 بلین ڈالر کا طیّارہ بردار بحری جنگی جہاز ہے جو دو ایٹمی ری ایکٹروں سے چلتا ہے۔',
      body: [
        'یو ایس ایس رونلڈ ریگن ایک 1,092 فٹ لمبا، 6 بلین ڈالر کا طیّارہ بردار بحری جنگی جہاز ہے جو دو ایٹمی ری ایکٹروں سے چلتا ہے۔ یہ زمرہ نِمِٹز کا جہاز ہے۔',
        'امریکی بحریہ کے مطابق، اس جسامت کے باوجود، یہ 30 ناٹ (بحری میل) فی گھنٹہ سے زیادہ رفتار سے سفر کر سکتا ہے۔',
        'اس جہاز کا نام 1981 سے 1989 تک رہنے والے ریاست ہائے متحدہ امریکہ کے صدر رونلڈ ریگن کے اعزاز میں رکھا گیا ہے۔'
      ],
      image: 'images/carrier.jpg',
      language: 'urdu',
      category: 'ٹیکنالوجی',
      date: '2025-11-28'
    },
    {
      id: '12',
      slug: 'science-urdu-internet',
      title: 'سائنس اردو میں انٹرنیٹ پر',
      excerpt:
        'سائنس کے موضوعات پر اردو میں وبگاہیں اور کارگاہیں بڑھتی جا رہی ہیں۔ یہ ایک خوش آئیند بات ہے۔',
      body: [
        'سائنس کے موضوعات پر اردو میں وبگاہیں اور کارگاہیں بڑھتی جا رہی ہیں۔ یہ ایک خوش آئیند بات ہے۔',
        'اب تک انٹرنیٹ پر اردو میں مذہب، سیاست اور ادب کی اجارہ داری تھی؛ اب تبدیلی آئی ہے۔ ان کارگاہوں کے بنانے والوں کا شوق، لگن اور دل سے کام کرنا قابلِ تحسین ہے۔',
        'نیچے دیے ہوئے اردو اور انگریزی پتوں پر جا کر آپ اردو میں بھی سائنس پڑھ سکتے ہیں۔ کَڑیوں والے صفحے پر مکمل فہرست موجود ہے۔'
      ],
      image: 'images/science.jpg',
      language: 'urdu',
      category: 'سائنس',
      date: '2025-11-20'
    }
  ];

export const DEFAULT_LINKS: LinkItem[] = [
  { id: 'l1', title: 'عظمیٰ رومی چینل', url: 'https://www.youtube.com/@uzmarumi5256', note: 'یوٹیوب' },
  { id: 'l2', title: 'بی بی سی اردو — سائنس', url: 'https://www.bbc.com/urdu/topics/c40379e2ymxt', note: 'خبریں' },
  { id: 'l3', title: 'اردو ماہنامہ سائنس', url: 'https://akhbarurdu.com/urduscience/epaper.html', note: 'نئی دہلی' },
  { id: 'l4', title: 'کائنات سٹوڈیوز', url: 'https://www.kainaatstudios.com', note: 'ویڈیوز' },
  { id: 'l5', title: 'جہانِ سائنس', url: 'http://www.jahanescience.com/2020/03/science.books.in.urdu.html', note: 'کتب' },
  { id: 'l6', title: 'ریختہ — سائنس', url: 'https://www.rekhta.org/ebooks/category/children-s-literature/science-1', note: 'ای کتب' },
  { id: 'l7', title: 'سائنس ان مائی اردو', url: 'https://scienceinmyurdu.blogspot.com/', note: 'بلاگ' },
  { id: 'l8', title: 'سائنس کی دنیا', url: 'https://sciencekiduniyagroup.blogspot.com/', note: 'بلاگ' }
];

export const DEFAULT_DICTIONARIES: DictionaryEntry[] = [
  { id: 'd1', title: 'اردو لغت', desc: 'روزانہ کے سائنسی اور عام الفاظ کے آسان اردو معانی۔', language: 'اردو' },
  { id: 'd2', title: 'پنجابی لغت', desc: 'سائنس اور عام زندگی کے الفاظ پنجابی میں۔', language: 'پنجابی' },
  { id: 'd3', title: 'سندھی لغت', desc: 'سندھی زبان میں سائنسی اصطلاحات کی وضاحت۔', language: 'سندھی' },
  { id: 'd4', title: 'بلوچی لغت', desc: 'بلوچی میں علم و فن کے بنیادی الفاظ۔', language: 'بلوچی' },
  { id: 'd5', title: 'پشتو لغت', desc: 'پشتو میں سائنس اور صحت سے متعلق الفاظ۔', language: 'پشتو' }
];
